import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const updateConfigurationTodo = createAsyncThunk('updateConfiguration', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'configuration',
            data: {
                "min_edge": data.min_edge_trim,
                'max_edge': data?.max_edge_trim,
                "min_good_piece_length": data.min_good_piece_length,
                "min_final_length": data.min_final_length,
                "max_welds": data.max_welds_per_coil,
                "defect": JSON.stringify(data.defect_item),
                // "added_by": localStorage.getItem('userId')

            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') }
        })
        return res

    } catch (error) {
        return error?.response
    }
})




